import { render, staticRenderFns } from "./CreateDictModal.vue?vue&type=template&id=1846a125&v-slot=true&"
import script from "./CreateDictModal.vue?vue&type=script&lang=js&"
export * from "./CreateDictModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports